//
// Phone mixin
// ----------

define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');

    module.exports = {
        pastedLength: null,
        hyphenAmount: null,
        cursorStartBeforePast: null,
        cursorStart: null,

        additionalEvents: {
            'input .fn-validate[data-validation-type="phoneWithArea"] input': 'handlePhoneFormat',
            'beforeinput .fn-validate[data-validation-type="phoneWithArea"] input': 'setPastedData'
        },

        setPastedData: function({ data, inputType, target: { selectionStart } }) {
            if (inputType === 'insertFromPaste') {
                this.pastedLength = data.match(/[^-]/g)?.length || 0;
                this.hyphenAmount = data.match(/-/g)?.length || 0;
                this.cursorStartBeforePast = selectionStart;
            }
        },

        unSetPastedData: function() {
            this.hyphenAmount = null;
            this.pastedLength = null;
            this.cursorStartBeforePast = null;
            this.cursorStart = null;
        },

        insertHyphen: function(string, index) {
            return string.slice(0, index) + "-" + string.slice(index);
        },

        getClearPhone: function(phone) {
            return phone.replace(/-/g, '');
        },

        getFormattedPhone: function(rawPhone) {
            let phone = this.getClearPhone(rawPhone);

            if (phone.length >= 4) {
                phone = this.insertHyphen(phone, 3);
            }

            if (phone.length >= 8) {
                phone = this.insertHyphen(phone, 7);
            }

            return phone;
        },

        setCursor: function(event) {
            const target = event.target;

            //if the cursor placed to the left of the first hyphen, after "delete" it should appear to the right of it
            if (this.cursorStart === 3 && event.inputType === 'deleteContentForward') {
                this.cursorStart = this.cursorStart + 1;

                target.setSelectionRange(this.cursorStart, this.cursorStart);

                return;
            }

            //if the cursor placed to the left of the second hyphen, after "delete" it should appear to the right of it
            if (this.cursorStart === 7 && event.inputType === 'deleteContentForward') {
                this.cursorStart = this.cursorStart + 1;

                target.setSelectionRange(this.cursorStart, this.cursorStart);

                return;
            }

            //if the cursor placed to the right of the second hyphen, after "backspace" it should appear to the left of it
            if (this.cursorStart === 7 && event.inputType === 'deleteContentBackward') {
                target.setSelectionRange(this.cursorStart, this.cursorStart);

                return;
            }

            //correction when adding a text and it should be transferred through hyphen
            if (this.cursorStart === 4 && event.inputType === 'insertText') {
                this.cursorStart = this.cursorStart + 1;
            }

            if (this.cursorStart === 8 && event.inputType === 'insertText') {
                this.cursorStart = this.cursorStart + 1;
            }

            /*
            *in the case of pasting from the buffer, the cursor should be shifted to the right
            *by the number of hyphens that break inserted text
            */
            if (event.inputType === 'insertFromPaste') {
                if (this.cursorStartBeforePast <= 3 && this.pastedLength >= 4 - this.cursorStartBeforePast && this.pastedLength < 7 - this.cursorStartBeforePast
                || this.cursorStartBeforePast >= 4 && this.cursorStartBeforePast <= 7 && this.pastedLength >= 8 - this.cursorStartBeforePast) {
                    this.cursorStart = this.cursorStart + 1;
                } else if (this.cursorStartBeforePast <= 3 && this.pastedLength >= 7 - this.cursorStartBeforePast) {
                    this.cursorStart = this.cursorStart + 2;
                }

                //also cursor should be shifted to the left by the number of hyphens that was in buffer before getFormattedPhone-method
                this.cursorStart = this.cursorStart - this.hyphenAmount;
            }

            target.setSelectionRange(this.cursorStart, this.cursorStart);
        },

        getPhoneBeforeSend: function(rawPhone) {
            const cleanPhone = this.getClearPhone(rawPhone);

            return rawPhone.startsWith('+1') ? cleanPhone : `+1${cleanPhone}`;
        },

        handlePhoneFormat:  _.debounce(function(event) {
            const target = event.target;

            this.cursorStart = target.selectionStart;
            target.value = this.getFormattedPhone(target.value);
            this.setCursor(event);

            if (event.inputType === 'insertFromPaste') {
                this.unSetPastedData();
            }
        })
    };
});
